import theme from "./theme.js";

const borderBottom1px = props =>`
  position: relative;
  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    height: 1px;
    background-color: ${props.borderBcolor || theme.colors.border};
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    pointer-events: none;
  }
`;

const borderTop1px = props =>`
  position: relative;
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 1px;
    background-color: ${props.borderTcolor || theme.colors.border};
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    pointer-events: none;
  }
`;

const borderRight1px = props =>`
  position: relative;
  &:after {
    content: '';
    display: block;
    position: absolute;
    height: 100%;
    right: 0;
    top: 0;
    width: 1px;
    background-color: ${props.borderRcolor || theme.colors.border};
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
    pointer-events: none;
  }
`;

const borderLeft1px = props =>`
  &:after {
    content: '';
    display: block;
    position: absolute;
    height: 100%;
    right: 100%;
    top: 0;
    width: 1px;
    background-color: ${props.borderLcolor || theme.colors.border};
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
    pointer-events: none;
  }
`;

/*四边*/
const bdAll1px = props =>`
  position: relative;
  &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 200%;
      height: 200%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      -webkit-transform-origin: left top;
      transform-origin: left top;
      border: 1px solid ${props.borderAllcolor || theme.colors.border};
      border-radius: ${props.borderAllRadius || '3px'};
  }
`;

const box = `
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-box;
  display: box;
  display: -webkit-flex;
  display: flex;
`;

/* 平均分配 */
const flex = props =>`
  -ms-flex: $order;
  -webkit-box-flex: ${props.flexOrder};
  -webkit-flex: ${props.flexOrder};
  flex: ${props.flexOrder};
`;

/* 自定义宽度 */
const autoFlex = `
  -webkit-box-flex: 0 0 auto;
  -webkit-flex: 0 0 auto;
  flex: 0 0 auto;
`;

/* 垂直居中 */
const verticalCenter = `
  -webkit-box-align: center;
  box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
`;

/* 垂直靠上 */
const verticalTop = `
  box-align: start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-align-items: flex-start;
`;

/* 垂直靠下 */
const verticalEnd = `
  box-align: end;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
  -webkit-align-items: flex-end;
`;

/* 水平居中 */
const horizontalCenter = `
  box-pack: center;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-justify-content: center;
`;

/* 两边对齐 */
const bothSide = `
  box-pack: justify;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-justify-content: space-between;
`;

/* 换行 */
const wrap = `
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
`;

export {
  borderBottom1px,
  borderTop1px,
  borderRight1px,
  borderLeft1px,
  bdAll1px,
  box,
  flex,
  autoFlex,
  verticalCenter,
  verticalTop,
  verticalEnd,
  horizontalCenter,
  bothSide,
  wrap
};


  
